import React, { useState } from "react";
import { Button, Icon, Popup } from "semantic-ui-react";
import { useCurrentHotel } from "../../hooks/useCurrentHotel";
import { useTextResources } from "../../language";
import YieldPopup from '../YieldPopup'
import RestrictionsPopup from '../RestrictionsPopup'
import PriceUpdatePopup from '../PriceUpdatePopup'
import PropTypes from 'prop-types'
import { AllocationDatesPopup } from "../AllocationAndStrategy/AllocationDatesPopup";
import { HotelFeatureCodes } from "../shared/constants";
import BulkUpdateHotelDateParameterPopup from '../BulkUpdateHotelDateParameterPopup';
import ValidateModalPermission from '../shared/ValidateModalPermission';
import { PermissionsActions } from '../shared/permissionsActions';

export const MonthlySideMenu = ({ onSavePopup, selectedDate }) => {
    const currentHotel = useCurrentHotel()
    const text = useTextResources()
    const [showYieldPopup, setShowYieldPopup] = useState(false)
    const [showRestrictionsPopup, setShowRestrictionsPopup] = useState(false)
    const [showPriceUpdatePopup, setShowPriceUpdatePopup] = useState(false)
    const [showDatesPopup, setShowDatesPopup] = useState(false)
    const [showBulkUpdateHotelDateParameterPopup, setShowBulkUpdateHotelDateParameterPopup] = useState(false)
    const allocationFeatureEnabled = currentHotel?.HotelFeatures?.find(hf => hf.FeatureID == HotelFeatureCodes.Allocations) !== null;

    const menu = [
        {
            text: "YieldUpdate",
            className: "icon-calculator",
            callback: setShowYieldPopup,
            disabled: false
        },
        {
            text: "RestrictionPopup",
            className: "icon-do-not-disturbe",
            callback: setShowRestrictionsPopup,
            disabled: false
        },
        {
            text: "PricePopup",
            className: "icon-price-tag",
            callback: setShowPriceUpdatePopup,
            disabled: false
        }
    ];
    if (allocationFeatureEnabled) {
        menu.push({
            text: "EditAllocationDates",
            className: "icon-calendarnumber",
            callback: setShowDatesPopup,
            disabled: false
        })
    }
    
    // Add bulk update hotel date parameters button
    menu.push({
        text: "BulkUpdateHotelDateParameters",
        className: "icon-calendar",
        callback: setShowBulkUpdateHotelDateParameterPopup,
        disabled: false
    })

    return (
        <>
            <Button.Group vertical icon style={{ float: "left" }}>
                {
                    menu.map((x, idx) => {
                        return <Popup key={idx} position='top right' content={text(x.text)} trigger={
                            <Button as={'a'} disabled={x.disabled} href={x.url} icon onClick={() => x.callback(true)}>
                                <Icon size="big" className={x.className} />
                            </Button>
                        } />
                    })
                }
            </Button.Group>
            {/* HS-70186: each popup is mounted only while open. Mounted closed they each
                fetched on page load (HotelParameters, RoomTypes x2, Rates x2, ...), competing
                with the grid's first load. All of them reset their fields on close anyway. */}
            {showYieldPopup && <YieldPopup
                open={showYieldPopup}
                HotelID={currentHotel?.Id}
                onClose={() => setShowYieldPopup(false)}
                onSave={() => onSavePopup?.()}
                initialDate={selectedDate}
            />}
            {showRestrictionsPopup && <RestrictionsPopup
                HotelID={currentHotel?.Id}
                onClose={() => setShowRestrictionsPopup(false)}
                open={showRestrictionsPopup}
                onSave={() => onSavePopup?.()}
                initialDate={selectedDate}
            />}
            {showPriceUpdatePopup && <PriceUpdatePopup
                HotelID={currentHotel?.Id}
                onClose={() => setShowPriceUpdatePopup(false)}
                open={showPriceUpdatePopup}
                onSave={() => onSavePopup?.()}
                initialDate={selectedDate}
            />}
            {showDatesPopup && <AllocationDatesPopup
                hotelId={currentHotel?.Id}
                open={showDatesPopup}
                onClose={() => setShowDatesPopup(false)}
                onSave={() => onSavePopup?.()}
                initialDate={selectedDate}
                isPerReservation={false}
            />}
            <ValidateModalPermission
                open={showBulkUpdateHotelDateParameterPopup}
                onClose={() => setShowBulkUpdateHotelDateParameterPopup(false)}
                actionId={PermissionsActions.EditHotelDateParameters}
                noPermissionMessage={text("NoPermissionToEditHotelDateParameters")}
            >
                <BulkUpdateHotelDateParameterPopup
                    open={showBulkUpdateHotelDateParameterPopup}
                    onClose={() => setShowBulkUpdateHotelDateParameterPopup(false)}
                    onSave={() => onSavePopup?.()}
                    initialDate={selectedDate}
                />
            </ValidateModalPermission>
        </>


    )
}

MonthlySideMenu.propTypes = {
    onSavePopup: PropTypes.func
}